import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { OrderSearchSchema } from "#/lib/schemas/order-search";
import { OrdersPage } from "#/components/pages/orders/orders-page";

export const Route = createFileRoute("/$tenantCode/$market/orders")({
  beforeLoad: () => ({ getTitle: () => m["resources.order.name"]() }),
  validateSearch: OrderSearchSchema,
  component: OrdersRoute,
});

function OrdersRoute() {
  const { searched, orderFilters, page, perPage, sort } = Route.useSearch();

  return (
    <OrdersPage
      searched={searched}
      orderFilters={orderFilters}
      page={page}
      perPage={perPage}
      sort={sort}
    />
  );
}
